module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 6
// module chunks = 1